import { useCheckSignatureStatusLazyQuery } from 'api/core/generated';
import { AppApiVersions } from 'app-constants';
import { useCallback } from 'react';

const SIGNATURE_STATUS_POLL_INTERVAL = 3000; // 3 seconds as per ticket

export const useCheckSignatureStatus = () => {
  const [pollSignatureStatus, { data, loading, error, stopPolling, called }] =
    useCheckSignatureStatusLazyQuery({
      context: { apiVersion: AppApiVersions.core },
      fetchPolicy: 'network-only',
      pollInterval: SIGNATURE_STATUS_POLL_INTERVAL,
    });

  const startSignatureStatusPolling = (sessionId: string) =>
    pollSignatureStatus({ variables: { session_id: sessionId } });

  // Only call stopPolling if the query has actually been started
  // to prevent enabling polling when it hasn't been started yet
  const stopSignatureStatusPolling = useCallback(() => {
    if (called) {
      stopPolling();
    }
  }, [called, stopPolling]);

  return {
    startSignatureStatusPolling,
    stopSignatureStatusPolling,
    signatureStatus: data?.status ?? null,
    signatureStatusLoading: loading,
    signatureStatusError: error,
    signatureStatusPollingStarted: called,
  };
};
